"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const gameplay_1 = require("../gameplay");
function useUserChoices(gameplayControl, expectedChoices, inputMode) {
    // user choices now will have prefilled empty strings, length is the same as expected choices
    const [userChoices, setUserChoices] = (0, react_1.useState)([]);
    const [isFulfilled, setIsFulfilled] = (0, react_1.useState)(false);
    // this means where index is in user choices
    const [currentIndex, setCurrentIndex] = (0, react_1.useState)(-1);
    (0, react_1.useEffect)(() => {
        const emptyChoices = expectedChoices.map(() => '');
        setUserChoices(emptyChoices);
        if (emptyChoices.length > 0) {
            setCurrentIndex(0);
        }
    }, [expectedChoices]);
    (0, react_1.useEffect)(() => {
        if (gameplayControl === gameplay_1.GameplayControl.PresentQuestion) {
            switch (inputMode) {
                case 'FULL_TEXT':
                    {
                        if (userChoices.length > 0 &&
                            userChoices.length === expectedChoices.length &&
                            userChoices.every(choice => choice.length > 0)) {
                            setIsFulfilled(true);
                            return;
                        }
                    }
                    break;
                case 'SPELLING':
                    {
                        if (userChoices.length > 0 &&
                            userChoices.length === expectedChoices.length &&
                            userChoices.every((choice, index) => choice.length === expectedChoices[index].length)) {
                            setIsFulfilled(true);
                            return;
                        }
                    }
                    break;
            }
            // is not fulfilled in question
            setIsFulfilled(false);
        }
        else {
            // gameplay control is not in question,
            setIsFulfilled(true);
        }
    }, [userChoices, expectedChoices, gameplayControl, inputMode]);
    const addChoice = (0, react_1.useCallback)((choice) => {
        if (gameplayControl !== gameplay_1.GameplayControl.PresentQuestion) {
            return;
        }
        if (choice.length === 0) {
            return;
        }
        if (currentIndex >= userChoices.length) {
            return;
        }
        const newUserChoices = [...userChoices];
        switch (inputMode) {
            case 'FULL_TEXT':
                {
                    // assign the choice to current index
                    // and then move to next index
                    newUserChoices[currentIndex] = choice;
                    setUserChoices(newUserChoices);
                    const nextIndex = findNextAvailableBlankIndex(newUserChoices, expectedChoices, currentIndex, inputMode);
                    setCurrentIndex(nextIndex);
                }
                break;
            case 'SPELLING':
                {
                    //check if choice at current index is fulfilled
                    // not fulfilled: append choice at current index
                    // fulfilled: move to next index and append to the new index
                    const curExpectedChoice = expectedChoices[currentIndex];
                    if (userChoices[currentIndex].length < curExpectedChoice.length) {
                        // append choice to the last choice str
                        const choiceFromCurrIndex = userChoices[currentIndex];
                        const newChoice = choiceFromCurrIndex + choice;
                        newUserChoices[currentIndex] = newChoice;
                        setUserChoices(newUserChoices);
                        if (newChoice.length === curExpectedChoice.length) {
                            const nextIndex = findNextAvailableBlankIndex(newUserChoices, expectedChoices, currentIndex, inputMode);
                            setCurrentIndex(nextIndex);
                        }
                    }
                    else {
                        const nextIndex = findNextAvailableBlankIndex(newUserChoices, expectedChoices, currentIndex, inputMode);
                        setCurrentIndex(nextIndex);
                        const choiceFromNextIndex = userChoices[nextIndex];
                        const newChoice = choiceFromNextIndex + choice;
                        newUserChoices[nextIndex] = newChoice;
                        setUserChoices(newUserChoices);
                    }
                }
                break;
        }
    }, [gameplayControl, expectedChoices, inputMode, userChoices, currentIndex]);
    const replaceChoice = (0, react_1.useCallback)((index, choice) => {
        if (gameplayControl !== gameplay_1.GameplayControl.PresentQuestion) {
            return;
        }
        if (index >= userChoices.length) {
            return;
        }
        const newUserChoices = [...userChoices];
        newUserChoices[index] = choice;
        setUserChoices(newUserChoices);
        if ((inputMode === 'FULL_TEXT' && choice.length > 0) ||
            (inputMode === 'SPELLING' &&
                choice.length === expectedChoices[index].length)) {
            const nextIndex = findNextAvailableBlankIndex(newUserChoices, expectedChoices, index, inputMode);
            setCurrentIndex(nextIndex);
        }
    }, [gameplayControl, userChoices]);
    const deleteLastCharacterAt = (0, react_1.useCallback)((index) => {
        if (gameplayControl !== gameplay_1.GameplayControl.PresentQuestion) {
            return;
        }
        if (index >= userChoices.length) {
            return;
        }
        if (inputMode === 'SPELLING') {
            if (userChoices[index].length === 0) {
                if (index === 0) {
                    return;
                }
                else {
                    const newIndex = index - 1;
                    setCurrentIndex(newIndex);
                    setUserChoices(prev => {
                        const newArray = [...prev];
                        const choice = newArray[newIndex];
                        const newChoice = choice.slice(0, choice.length - 1);
                        newArray[newIndex] = newChoice;
                        return newArray;
                    });
                    return;
                }
            }
            setUserChoices(prev => {
                const newArray = [...prev];
                const choice = newArray[index];
                const newChoice = choice.slice(0, choice.length - 1);
                newArray[index] = newChoice;
                return newArray;
            });
        }
    }, [gameplayControl, userChoices, inputMode]);
    // const removeLastChoice = useCallback(() => {
    //   if (gameplayControl !== GameplayControl.PresentQuestion) {
    //     return;
    //   }
    //   if (userChoices.length === 0) {
    //     return;
    //   }
    //   switch (inputMode) {
    //     case 'FULL_TEXT':
    //       {
    //         setUserChoices(prev => [...prev.slice(0, prev.length - 1)]);
    //       }
    //       break;
    //     case 'SPELLING':
    //       {
    //         setUserChoices(prev => {
    //           const newArray = [...prev];
    //           if (newArray.length > 0) {
    //             const lastIndex = newArray.length - 1;
    //             const lastElement = newArray[lastIndex];
    //             if (lastElement.length > 0) {
    //               newArray[lastIndex] = lastElement.slice(0, -1);
    //             }
    //             if (newArray[lastIndex] === '') {
    //               newArray.pop();
    //             }
    //           }
    //           return newArray;
    //         });
    //       }
    //       break;
    //   }
    // }, [gameplayControl, userChoices, inputMode]);
    const resetUserChoices = (0, react_1.useCallback)(() => {
        setUserChoices([]);
    }, []);
    return {
        userChoices,
        currentIndex,
        setCurrentIndex,
        isFulfilled,
        addChoice,
        replaceChoice,
        deleteLastCharacterAt,
        // removeLastChoice,
        resetUserChoices,
    };
}
exports.default = useUserChoices;
function findNextAvailableBlankIndex(userChoices, expectedChoices, currentIndex, inputMode) {
    if (expectedChoices.length === 0 || currentIndex >= expectedChoices.length) {
        return -1;
    }
    let nextIndex = (currentIndex + 1) % userChoices.length;
    while (nextIndex !== currentIndex) {
        const currentChoice = userChoices[nextIndex];
        const expectedChoice = expectedChoices[nextIndex];
        switch (inputMode) {
            case 'FULL_TEXT':
                if (typeof currentChoice !== 'undefined' &&
                    currentChoice.length === 0) {
                    return nextIndex;
                }
                break;
            case 'SPELLING':
                if (typeof currentChoice !== 'undefined' &&
                    currentChoice.length < expectedChoice.length) {
                    return nextIndex;
                }
        }
        nextIndex += 1;
        nextIndex = nextIndex % userChoices.length;
    }
    return -1;
}
